// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Col/Col.sass
// module id = 349
// module chunks = 0